/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Timeline_Select_Next_EventInputs */



/**
* | output |
* | --- |
* | "Select Next Event On Timeline" |
*
* @param {Shortcut_Keys_Name_Timeline_Select_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_timeline_select_next_event = /** @type {((inputs?: Shortcut_Keys_Name_Timeline_Select_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Timeline_Select_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner l'evenement suivant sur la timeline")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächstes Ereignis in der Zeitleiste auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona l'evento successivo nella cronologia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите следующее событие на временной шкале")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar el próximo evento en la línea de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在时间线上选择下一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムライン上の次のイベントを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमलाइन पर अगला इवेंट चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o próximo evento na linha do tempo.")
	return /** @type {LocalizedString} */ ("Select Next Event On Timeline")
});